import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,{staticClass:"container-height d-flex align-center justify-center",class:_vm.reduced ? 'container-height-reduced' : 'container-height',attrs:{"fluid":""}},[_c('div',{staticClass:"text-center"},[_c(VIcon,{staticClass:"text--disabled",attrs:{"size":_vm.isMobile ? 70 : 100}},[_vm._v("mdi-database-remove")]),_c('p',{staticClass:"text-center text--disabled font-weight-medium",class:{
				'text-h5': _vm.isMobile,
				'text-h4': !_vm.isMobile,
			}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }